export default __webpack_public_path__ + "static/media/Ellipse2.c4603309.png";